module.exports = __webpack_public_path__ + "static/assets/martha-jules-profile.e799527.png";